// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Store
import { selectAuthIsLoading } from '../../feature/selectors';
import { resetPassword } from '../../feature/actionCreators';

// Components
import { showErrorToast, showSuccessToast } from '@/components';
import { StyledFormWrapper, StyledLayout, StyledPageWrapper } from './ResetPasswordContainerStyles';
import ResetPasswordForm from '../../components/ResetPasswordForm/ResetPasswordForm';

// Models
import { ROUTES } from '@/models/router.model';

// Helpers
import { TResetPasswordFormValues } from '../../helpers/types';
import { useAuthorizedRedirect } from '../../hooks';
import { useAppDispatch, useAppState } from '@/hooks';
import ResetPasswordDTO from '../../dtos/ResetPasswordDTO';

const ResetPasswordContainer = () => {
  const { t } = useTranslation(['auth']);
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectAuthIsLoading);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const authSessionId = searchParams.get('session');
  const goToLogin = () => navigate(ROUTES.SIGN_IN);

  const handleSubmit = async (values: TResetPasswordFormValues) => {
    if (!authSessionId) return showErrorToast({ message: t('auth_session_id_error') });

    if (!code) return showErrorToast({ message: t('auth_confirmation_code_error') });

    const dto = new ResetPasswordDTO(values, code, authSessionId);

    try {
      await dispatch(resetPassword(dto)).unwrap();
      showSuccessToast({ message: t('auth_reset_success_message') });
      goToLogin();
    } catch (err) {
      console.error(err);
    }
  };

  useAuthorizedRedirect();

  return (
    <StyledLayout>
      <StyledPageWrapper>
        <StyledFormWrapper>
          <ResetPasswordForm handleSubmit={handleSubmit} isLoading={isLoading} />
        </StyledFormWrapper>
      </StyledPageWrapper>
    </StyledLayout>
  );
};

export default ResetPasswordContainer;
